import React from 'react';
import Service from 'src/setup/network';

const useFetch = (url: string, noCall?: boolean) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState<any>([]);
  const [errorText, setErrorText] = React.useState('');

  const fetchData = React.useCallback(async () => {
    if (noCall) {
      return;
    }

    try {
      setIsLoading(true);
      const response = await Service.get(url);
      setData(response?.data?.data || response?.data);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      setErrorText(error?.response?.data);
    }
  }, [url]);

  React.useEffect(() => {
    fetchData();
  }, [url]);
  return { isLoading, data, errorText, fetchData };
};

export default useFetch;
